module.exports = __webpack_public_path__ + "static/media/transporter-1.fd87681c.svg";